import { useSelector } from "react-redux";

export const useCurrentBranch = () => {
  const { selectedBranch } = useSelector((state) => state.rate.ui);
  const { user } = useSelector((state) => state.auth);

  const currentBranch =
    selectedBranch || user?.branchAccess?.primaryBranch || "";
  const hasBranchAccess = !!currentBranch;

  return {
    currentBranch,
    hasBranchAccess,
    primaryBranch: user?.branchAccess?.primaryBranch,
    secondaryBranches: user?.branchAccess?.secondaryBranches || [],
    allBranches: [
      user?.branchAccess?.primaryBranch,
      ...(user?.branchAccess?.secondaryBranches || []),
    ].filter(Boolean),
  };
};
